import Router from "vue-router";
import Vue from "vue";
Vue.use(Router);
const vueRouter = new Router({
  mode: "history",
  base: process.env.VUE_APP_PATH,
  routes: [
    {
      path: "/",
      name: "list",
      component: () => import(/* webpackChunkName: "page" */ "@/page/index"),
    },
    {
      path: "/create",
      name: "create",
      component: () => import(/* webpackChunkName: "page" */ "@/page/create"),
    },
    {
      path: "/build/:id",
      name: "build",
      component: () => import(/* webpackChunkName: "page" */ "@/page/build"),
    },
    {
      path: "/view/:id",
      name: "view",
      component: () => import(/* webpackChunkName: "page" */ "@/page/view"),
    },
    {
      path: "/graph/process",
      name: "graphGrocess",
      component: () =>
        import(
          /* webpackChunkName: "page" */
          "@/page/graph/process/EditorCom.vue"
        ),
    },
    {
      path: "/graph/alarmFilterEditor",
      name: "alarmFilterEditor",
      component: () =>
        import(
          /* webpackChunkName: "page" */
          "@/page/graph/alarmFilter/alarmFilterEditor.vue"
        ),
    },
    {
      path: "/graph/topology",
      name: "graphTopology",
      component: () =>
        import(
          /* webpackChunkName: "page" */
          "@/page/graph/topology/topologyEditor.vue"
        ),
    },
    {
      path: "/graph/topologyView",
      name: "graphTopologyView",
      component: () =>
        import(
          /* webpackChunkName: "page" */
          "@/page/graph/topology/topologyView.vue"
        ),
    },
  ],
});
export default vueRouter;
